//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PriceTable',
  props: {
    tickets: {
      type: Array,
      required: true,
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/PriceTable.vue